'use client';

import { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { Toaster } from 'sonner';
import Overlay from '@/components/overlay';

import Sidebar from './sidebar';
import Header from './header';
import CookiePolicy from './cookie-policy';

interface MainProps {
  isCookieConsent: true | undefined;
  isPosthogIdentify: true | false | undefined;
  children: ReactNode;
}

const Main = ({ isCookieConsent, isPosthogIdentify, children }: MainProps) => {
  const pathname = usePathname();

  const isPrivacyPolicyPage = pathname === '/privacy-policy';

  return (
    <div className='flex min-h-screen h-full'>
      <Toaster
        position='top-right'
        duration={2500}
        closeButton
        toastOptions={{
          style: {
            border: 'none',
          },
          classNames: {
            toast: 'bg-surface-secondary',
            title: 'text-text-primary',
          },
        }}
      />
      {!isPrivacyPolicyPage && <CookiePolicy isCookieConsent={isCookieConsent} isPosthogIdentify={isPosthogIdentify} />}
      <div>
        <Sidebar />
        {isPrivacyPolicyPage && !isCookieConsent && <Overlay className='hidden lg:block fixed top-0 left-0 w-[264px]' />}
      </div>
      <div className='flex flex-col h-full w-full relative lg:ml-[264px] pt-[74px] lg:pt-[94px] '>
        {!isPrivacyPolicyPage && <Header />}
        <main className='flex flex-col h-full overflow-y-auto'>{children}</main>
      </div>
    </div>
  );
};

export default Main;
